import { IResponse, Model, ObjectsFactory } from '@/data'
import { FAUCET_ENDPOINT } from '@/data/endpoint'

export interface FaucetPayload {
  networkId: string
  tokenId: string
  recipientAddress: string
}

export interface FaucetResponse {
  tx: string
}

export class Faucet extends Model {
  static config = { endpoint: FAUCET_ENDPOINT }

  static objects = ObjectsFactory.factory(Faucet.config)

  static async requestFaucet(payload: FaucetPayload) {
    return await this.service.post<IResponse<FaucetResponse>>({
      url: FAUCET_ENDPOINT,
      payload,
    })
  }
}

Faucet.init(Faucet.config)
